// extracted by mini-css-extract-plugin
module.exports = {"contents":"Vd","sectionHeading":"Wd"};